import { Grid, Link, Typography, IconButton } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import YouTubeIcon from "@mui/icons-material/YouTube";
import FacebookIcon from "@mui/icons-material/Facebook";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { isMobile } from "react-device-detect";
import clsx from "clsx";

const useStyle = makeStyles({
  content: {
    fontFamily: "DB Heavent Med",
    color: "var(--white)",
    marginTop: "40%",
    //marginBottom: "50%",
  },
  content2: {
    paddingTop: "5%",
    color: "var(--white)",
    height: "100%",
  },
  boxContent: {
    direction: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  boxFooterContent: {
    fontFamily: "DB Heavent Med",
    direction: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  colorWhite: {
    color: "var(--white)",
  },
  textLeft: {
    textAlign: "left",
  },
  contentLeft: {
    height: "100%",
    width: "100%",
    paddingLeft: "10%",
    paddingTop: "10%",
    textAlign: "left",
  },
  paddingText: {
    padding: "20px 0",
  },
});
const BoxLeftContent = (props) => {
  const classes = useStyle();
  const { ndid_list, translations, isHome, clickBack, editUrl } = props;
  const goBack = () => {
    clickBack(true);
  };
  return isHome ? (
    <>
      <Grid className={classes.content}>
        <Grid>
          <Grid container className={classes.boxContent} spacing={2}>
            <Grid item xs={8}>
              <Grid className="text-center font-48">
                {translations?.home?.project_name.toUpperCase()}
              </Grid>
            </Grid>
            <Grid item xs={12} className="text-center font-20">
              {translations?.home?.project_description.toUpperCase()}
            </Grid>
            <Grid item xs={12}>
              <Grid>
                <Grid
                  container
                  className={classes.boxFooterContent}
                  spacing={2}
                >
                  <Grid item>
                    <Grid className="text-pointer">
                      <Link
                        className={classes.colorWhite}
                        href={translations?.home?.facebook.url}
                        underline="none"
                        target="_blank"
                      >
                        <Grid
                          container
                          className={classes.boxFooterContent}
                          spacing={1}
                        >
                          <Grid item>
                            <FacebookIcon />
                          </Grid>
                          <Grid item>
                            <Grid className="font-18">
                              {translations?.home?.facebook.name.toUpperCase()}
                            </Grid>
                          </Grid>
                        </Grid>
                      </Link>
                    </Grid>
                  </Grid>
                  <Grid item>
                    <Grid className="text-pointer">
                      <Link
                        className={classes.colorWhite}
                        href={translations?.home?.youtube.url}
                        underline="none"
                        target="_blank"
                      >
                        <Grid
                          container
                          className={classes.boxFooterContent}
                          spacing={1}
                        >
                          <Grid item>
                            <YouTubeIcon />
                          </Grid>
                          <Grid item>
                            <Grid className="font-18">
                              {translations?.home?.youtube?.name.toUpperCase()}
                            </Grid>
                          </Grid>
                        </Grid>
                      </Link>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  ) : (
    <Grid className={classes.content2}>
      <Grid className={isMobile ? "content mb" : "content"}>
        <Grid className="content-main">
          <Grid className="box-header">
            <Grid
              className={clsx(
                classes.colorWhite,
                classes.textLeft,
                "text-pointer",
                "box-title-left"
              )}
              sx={{ marginLeft: "-10px" }}
            >
              {!ndid_list && !editUrl && (
                <IconButton id="goBack" aria-label="goBack" onClick={() => goBack()}>
                  <ArrowBackIcon style={{color: "white"}}/>
                </IconButton>
              )}
            </Grid>
            <Grid className={classes.contentLeft}>
              <Typography className="font-24 font-weight-400">
                {translations?.header}
              </Typography>
              <Typography className="font-24 font-weight-400">
                {translations?.sub_header}
              </Typography>
              <Typography
                className={clsx(
                  classes.paddingText,
                  "font-20 font-DBHeavent font-normal"
                )}
                dangerouslySetInnerHTML={{
                  __html: translations?.description?.toUpperCase(),
                }}
              />

              <Typography
                className="font-20 font-DBHeavent font-normal"
                dangerouslySetInnerHTML={{
                  __html: translations?.sub_description,
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
export default BoxLeftContent;
